import React from 'react'
import {Menu, ExitToApp} from '@mui/icons-material'
import {AppBar, Button, IconButton, Toolbar} from '@mui/material'

import {BRAND_LOGO_LINK} from '../../lib/constant'
import {GAEventTracker} from '../../lib/googleAnalytics'
import AccountMenu from './AccountMenu'
import SMSBalanceHeader from './SMSBalanceHeader'
import {decodeJwtPayload} from '../../auth/tokenUtils'
import OfferBanner from '../OfferBanner'

const getImpersonation = () => {
  try {
    const raw = sessionStorage.getItem('combird_impersonation');
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
};

// The business name of the impersonated customer: what the admin panel passed
// in, else the org_name claim of the impersonated token, else the org id.
const impersonatedOrgName = (impersonation) => {
  if (!impersonation) return '';
  if (impersonation.targetOrgName) return impersonation.targetOrgName;
  const claims = decodeJwtPayload(impersonation.accessToken) || {};
  return claims.org_name || impersonation.targetOrgId || '';
};

const exitImpersonation = () => {
  sessionStorage.removeItem('combird_impersonation');
  sessionStorage.removeItem('combird_actor_token');
  window.location.reload();
};

const MenuBar = ({instituteName, title, handleDrawer}) => {
  const isMobile = window.isMobile()
  const impersonation = getImpersonation();
  // While impersonating, the header names the CUSTOMER's business, not the
  // admin's own org — support must see at a glance whose account this is.
  const orgName = impersonatedOrgName(impersonation);
  const headerName = impersonation ? (orgName || instituteName) : instituteName;
  return (
    <AppBar position="fixed" sx={{zIndex: 1201}}>
      {impersonation && (
        <div style={{
          background: '#e57373', color: '#fff', display: 'flex',
          alignItems: 'center', justifyContent: 'center', padding: '4px 16px',
          fontSize: 13, gap: 12
        }}>
          <span>Impersonating <b>{orgName || impersonation.targetOrgId}</b> — user {impersonation.targetUserName || impersonation.targetUserId}</span>
          <Button size="small" variant="outlined"
            sx={{color: '#fff', borderColor: '#fff', textTransform: 'none', py: 0, minHeight: 24, fontSize: 12}}
            startIcon={<ExitToApp style={{fontSize: 14}} />}
            onClick={exitImpersonation}
          >
            Exit Impersonation
          </Button>
        </div>
      )}
      <OfferBanner />
      <Toolbar>
        <IconButton
          size="large"
          edge="start"
          color="inherit"
          aria-label="menu"
          sx={{mr: 2}}
          onClick={e => {e.stopPropagation();handleDrawer()}}
        >
          <Menu />
        </IconButton>
        <div style={ isMobile ? {fontSize: 16, flexGrow: 1} : {fontSize: 24, flexGrow: 1} }>
          {headerName}
          <span style={ isMobile ? {marginLeft: '24px', fontWeight: 300, fontSize: '16px'} : {marginLeft: '24px', fontWeight: 300, fontSize: '18px'} }>{title} </span>
        </div>
        { isMobile ? <AccountMenu /> :
          <div style={{display: 'flex', alignItems: 'center'}}>
            <SMSBalanceHeader />
            <a
              style={{marginLeft: 16}}
              href='https://combirds.com/'
              target='_blank'
              onClick={() => {GAEventTracker({category: 'Epadhai Logo', action: 'Logged-in User'});}}
            >
              <img
                src={BRAND_LOGO_LINK}
                alt=''
                style={{width: 50, height: 50, verticalAlign: 'middle'}}
              />
            </a>
            <AccountMenu />
          </div> }
      </Toolbar>
    </AppBar>
  )
}

export default MenuBar
